import axios from 'axios';

export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};

export const getToken = () => {
  const localStorageToken = localStorage.getItem('tokenAdmin');
  const sessionStorageToken = sessionStorage.getItem('tokenAdmin');
  const token = sessionStorageToken || localStorageToken || '';
  return axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

export const removeToken = () => {
  // Remove token from both localStorage and sessionStorage
  localStorage.removeItem("tokenAdmin");
  sessionStorage.removeItem("tokenAdmin");

  // Remove token from Axios headers
  delete axios.defaults.headers.common["Authorization"];
};